//defining the dependencies and files to be included
define('modules/profiles/main/views/board.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    "modules/profiles/models/profile.board.model",
    'modules/base/views/model.view',
    'modules/profiles/cards/views/card.view',
    'text!modules/profiles/main/templates/board.template.html'
], function(Prospector,$, _,Backbone,
            Marionette,
            ProfileBoardModel,
            BaseView,
            CardView,
            Template) {
    var BoardView = BaseView.extend({
        template: _.template(Template),
        className: 'boardHolder row animated fadeIn',
        modelSelector: '.cardHolder',
        loader: 'circleG_holder',
        loaderHtml: '<div class="boardload ripple_white_xl"><div></div><div></div></div>',
        mEvents:function() {
            var base = {
                'keyup .boardPageNum' : 'changePage'
            };
            var click = {
                //'click .settings': 'settings',
                //'click .viewComments': 'openAddComment',
                //'click .addCardBtn': 'openAddCard',
                //'click .addArticleBtn': 'openAddArticle', //added add article button
                'click .firstPage': 'firstPage',
                'click .previousPage': 'previousPage',
                'click .nextPage': 'nextPage',
                'click .lastPage': 'lastPage',
                'click .board': 'menuPopup'
            };
            $.extend(base,click);
            return base;
        },
        initialize: function(options){
            this.parent = options.parent;
            this.model = options.model;
            if(this.model.typeId == 7 ){
                Prospector.on('refreshBookmarks', this.refresh, this);
            }
            this.firstLoad = true;
            BaseView.prototype.initialize.call(this, options);
        },
        buildModel:function(){
            this.model = new ProfileBoardModel(this.model);
            this.model.pageSize = 10;
            if(this.parent.model.get('source').sourceId == 46 || this.parent.model.get('source').sourceId == 1046){
                this.model.dnb = 'include';
            }
            this.model.partyId = this.parent.model.get('id');
            this.fetchModel();
        },
        onRender:function(){
            this.$('.boardName').html(this.model.get('name'));
            //this.$('.profile > a').attr('href', window.location.href);
            if(this.model.get('typeId') == 8){
                this.$('.settings').remove();
            }
            if(this.filterSelector != ''){
                this.$(this.filterSelector).bind('keyup', $.proxy(this.querySearch, this));
            }
            /*this.$('.searchToggle').bootstrapSwitch({onText: 'On', offText: 'Off', onColor: 'primary', offColor:'primary'}).on('switchChange.bootstrapSwitch', $.proxy(function(event, state) {
                this.toggleSearch(event);
            }, this));*/
        },
        fetchModel:function(){
            this.cleanMySubviews();
            this.addLoader();
            this.model.once('sync', this.procModel, this);
            if(this.abortable){
                if(this.currXHR != undefined && this.currXHR.readyState > 0 && this.currXHR.readyState < 4){
                    this.currXHR.abort();
                }
            }
            if(this.mode == 'fetch'){
                this.currXHR = this.model.fetch();
            } else
            if(this.mode == 'save'){
                this.currXHR = this.model.save();
            }
        },
        changePage:function(event){
            var code = event.keyCode;
            if ((code>48 && code<57)||(code > 95 && code < 106)){
                this.procSearch();
            }
        },
        procSearch:function(){
            var val = this.getInputString();
            window.setTimeout(
                $.proxy(
                    this.procTimeBuildSearch,
                    this, val),
                window.typeAheadWait + Math.ceil(100 * Math.random()));
        },
        procTimeBuildSearch:function(val){
            var that = this;
            if(val == this.getInputString()){
                var maxPages = Math.ceil(this.model.get('totalCards') / this.model.pageSize);
                 if (val != "") {
                     var num = parseInt(val);
                     if (num <= maxPages) {
                         this.togglePage(num);
                     } else {
                        this.errOut("There are only " + maxPages + " pages!");
                     }
                 }
            }
        },
        getInputString:function(){
            var topVal = $(this.$('.boardPageNum')[0]).val();
            var bottomVal =  $(this.$('.boardPageNum')[1]).val();
            var val = "";
            if(topVal != this.model.page){
                val = topVal;
                this.nav = "top";
            } else {
                val = bottomVal;
                this.nav = "bottom";
            }
            return $.trim(val);
        },
        setNav:function(event){
            if($(event.target).hasClass('topBoardNav')){
                this.nav = "top";
            } else {
                this.nav = "bottom";
            }
        },
        firstPage:function(event){
            this.setNav(event);
            this.togglePage(1);
        },
        previousPage:function(event){
            this.setNav(event);
            this.togglePage(--this.model.page);
        },
        nextPage:function(event){
            this.setNav(event);
            this.togglePage(++this.model.page);
        },
        lastPage:function(event){
            this.setNav(event);
            this.togglePage(Math.ceil(this.model.get('totalCards') / this.model.pageSize));
        },
        togglePage:function(pageNum){
            var test = function(pageNum){
                this.model.page = pageNum;
                this.refresh();
            };
            if(this.nav != "top"){
                $('.secondRow').animate({scrollTop : 0}, 1200, "swing", $.proxy(
                    test, this, pageNum
                ));
            } else {
                $.proxy(test, this, pageNum)();
            }
        },
        /*toggleSearch:function(){
            if(this.$('.searchToggle').bootstrapSwitch('state')){
                this.model.applyFilter = "true";
            } else {
                this.model.applyFilter = "false";
            }
            this.model.page = 1;
            this.refresh();
        },*/
        refresh:function(){
            this.firstLoad = true;
            this.fetchModel();
        },
        showLoader: function(){
          this.$('.cardHolder').append(this.loaderHtml);
        },
        hideLoader:function(){
            $('.profileload').remove();
            $('.searchViewHolder').show();
        },
        procResponse:function(){
            if(Math.ceil(this.model.get('totalCards') / this.model.pageSize) < 2){
                if(this.isFirstLoad){
                    this.$('.boardNav').hide();
                }
            } else {
                this.$('.boardNav').show();
                this.$('.totalPages').html("of " + Math.ceil(this.model.get('totalCards') / this.model.pageSize));
                if(this.model.page == 1){
                    this.$('.firstPage').hide();
                    this.$('.previousPage').hide();
                } else {
                    this.$('.firstPage').show();
                    this.$('.previousPage').show();
                }

                if(this.model.page == Math.ceil(this.model.get('totalCards') / this.model.pageSize)){
                    this.$('.lastPage').hide();
                    this.$('.nextPage').hide();
                } else {
                    this.$('.lastPage').show();
                    this.$('.nextPage').show();
                }
            }
            this.$('.boardPageNum').val(this.model.page);

            this.firstLoad = false;
            if(this.model.get('cards') != undefined && this.model.get('cards').length > 0){
                var that = this;

                _.each(that.model.get('cards'), function(card){
                    if(card.typeId == 9  && !card.record.isHq){}
                    else if(card.typeId == 16){}
                    else if(card.typeId<27){
                        console.log("CARD TYPE ID: " + card.typeId);
                        var card = new CardView({model: card, parent: that});
                        this.$('.cardHolder').append(card.render().el);
                    }
                }, that);

                    /*if(this.options.bonus && $('.keyFacts').length === 0 || $('.companyKeyFacts').length === 0){ //
                        var profileCardModel = this.model.get('cards')[0];
                        var profileCard = new CardView({model: profileCardModel, parent: this});
                        $('.cardHolder').prepend(profileCard.render().el);
                        console.log("PREPEND COMPLETED");
                        this.hideLoader();
                    } else {
                        _.each(that.model.get('cards'), function(card){
                            if(card.typeId == 9  && !card.record.isHq){
                            } else {
                                var card = new CardView({model: card, parent: that});
                                this.$('.cardHolder').append(card.render().el);
                            }
                        }, that);
                        if($('.keyFacts').length > 0 || $('.companyKeyFacts').length === 0){
                            this.hideLoader();
                        }
                    }*/

            } else {
                if(this.hasFilters()){
                        this.$('.cardHolder').append(this.buildStatementCard('There are no cards matching your filters for this board.'));
                } else {
                    if(this.model.get('typeId') == 7){
                        this.$('.cardHolder').append(this.buildStatementCard('Relevant articles saved in the desktop web app will appear here.'));
                    } else {
                        this.$('.cardHolder').append(this.buildStatementCard('There are no cards for this board.'));
                    }
                }
            }

            this.updateCommentCount();
            this.updateFilterIndicator();
            if(this.model.canAddCard()){
                this.$('.addACardHolder').show();
            }
            //if the board model is correct, show add article button
            if(this.model.canAddArticle()){
                this.$('.addArticleHolder').show();
            }
            if(this.parent.isFirstLoad){
                Prospector.trigger('profileReceiveChild');
            }
            this.hideLoader();
        },
        buildStatementCard:function(text){
            return '<div class="card"><div class="secondaryLineFont mTop20 mBottom20">' + text + '</div></div>';
        },
        updateCommentCount:function(){
            if(this.model.get('comments').length == 0 ){
                this.$('.commentCount').html('');
                this.$('.viewComments').removeClass("fontOrange");
            } else {
                this.$('.commentCount').html(this.model.get('comments').length);
                this.$('.viewComments').addClass("fontOrange");
            }
        },
        hasFilters: function() {
            var hasFilters = _.any(this.model.get('filters'), function(filter){
                if(filter.typeId == 7 || filter.typeId == 8 || filter.typeId == 9){
                    if(filter.displayFlag){
                        return false;
                    } else {
                        return true;
                    }
                } else if (window.entitlements.get('settings').allowDotAlign && filter.typeId == 15) {
                    return filter.displayFlag;
                } else if(filter.typeId == 10 || filter.typeId == 11){
                    return false;
                } else {
                    if (filter.keywords.length == 0) {
                        return false;
                    } else {
                        return filter.keywords.length > 0;
                    }
                }
            });
            return hasFilters;
        },
        updateFilterIndicator:function() {
            if (this.hasFilters()) {
                this.$('.searchToggleHolder').show();
                if(this.model.applyFilter == "true"){
                    this.$('.searchToggle').bootstrapSwitch('state', true, true);
                } else {
                    this.$('.searchToggle').bootstrapSwitch('state', false, true);
                }
            } else {
                //this.$('.settings').removeClass('fontOrange');
                this.$('.searchToggle').bootstrapSwitch('state', false, true);
                this.$('.searchToggleHolder').hide();
            }
        },/*
        openAddCard:function(){
            Prospector.trigger('showCreateCard', {parent: this});
        },
        openAddArticle:function(){
            Prospector.trigger('showCreateArticle', {parent: this});
        },
        openAddComment:function(){
            Prospector.trigger('showBoardCommentsModal', {parent: this});
        },*/
        showDnBData:function(){
            this.model.dnb = 'include';
            this.refresh();
        },

        menuPopup: function(){
            if(window.location.href.indexOf("person") > -1){ // If current profile page is of a person
               if ($('.popMenu').is(":visible")) {
                   $('.popMenu').toggle('slide');
               }
            }

            if(window.location.href.indexOf("organization") > -1){// If current profile page is of a Organization
                if ($('.popMenu2').is(":visible")) {
                    $('.popMenu2').toggle('slide');
                }
            }
        },

        saveBoard:function(callback, scope){
            if(this.model.canModifyBoard()){
                $.proxy(callback, scope)();
            } else {
                this.model.set({
                    id: undefined,
                    profileId: this.parent.model.get('id')
                });
                this.model.once('sync', callback, scope);
                this.currXHR = this.model.save();
            }
        }
        /*settings:function(){
            if(this.model.get('typeId') == 9){
                Prospector.trigger("showFavoriteRolesGroupsControl", {parent: this, preSelectedBinType: "isFavorite"});
            } else {
                Prospector.trigger("showBoardFilter", {parent: this});
            }
        }*/
    });
    return BoardView;
});
